import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/kit";

export default function AuthCallback() {
  const done = useRef(false);
  const nav = useNavigate();
  const { signIn } = useAuth();
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api
      .post("/auth/google", { session_id: sid })
      .then(({ data }) => {
        signIn(data);
        nav("/dashboard", { replace: true });
      })
      .catch((e) => {
        toast.error(fmtErr(e));
        nav("/login", { replace: true });
      });
  }, [nav, signIn]);
  return <Spinner />;
}
